import type { DispatchAllocations, DispatchPreview } from '../dispatch.api';
import { useDispatchPermissions } from '../hooks/use-dispatch-permissions';
import { DispatchCrewCard } from './DispatchCrewCard';
import { DispatchTripOverview } from './DispatchTripOverview';

interface DispatchTripBodyProps {
  preview: DispatchPreview;
  isSubmitting: boolean;
  error: string | null;
  onDispatch: (allocations: DispatchAllocations) => Promise<void>;
  onOverridden: () => void;
}

/** Everything under the header once the preview has loaded: the crew, then the checks and the allocations. The trip's other work lives on its own page. */
export function DispatchTripBody({ preview, isSubmitting, error, onDispatch, onOverridden }: DispatchTripBodyProps) {
  const permissions = useDispatchPermissions();

  return (
    <div className="flex max-w-3xl flex-col gap-4">
      <DispatchCrewCard preview={preview} canChange={permissions.canDispatch && preview.trip.status === 'assigned'} />
      <DispatchTripOverview
        preview={preview}
        permissions={permissions}
        isSubmitting={isSubmitting}
        error={error}
        onDispatch={onDispatch}
        onChanged={onOverridden}
      />
    </div>
  );
}
